import {doc} from './documentation.js';
import {lazy} from './lazy.js';

doc(
    "source",
    {
        "x": "",
        "y": "",
    },
    "Transforms parameter to (x,y) coordinate"
);
export const source = (x,y) => (coords, ...args) => {
    let _coords = {};
    let _x = lazy(x, coords, ...args);
    let _y = lazy(y, coords, ...args);
    for (let id in coords) {
        _coords[id] = {
            ... coords[id],
            x: _x,
            y: _y
        };
    }
    return _coords;
};
